import styled from 'styled-components';

/**
 * L'élement utilisé pour afficher la grille de catégorie au sein d'une famille
 * La logique de calcul du nombre de colonnes et de sous-catégories à afficher
 * est mise en place directement au niveau du layout de `MenuLarge`. Ce layout
 * ne contient que les styles par défaut, à savoir 4 colonnes, et c'est tout.
 */
export const Container = styled.div`
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(4, 1fr);
`;
